import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['entities', 'toplevel'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.USER_PREFERENCES_BASE_URI}/entities/toplevel`,
        }),
        treatListResponse: (response) => response.data.user_entities,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'entities/toplevel',
    store,
  });

  basePlugin.onInit(() => {
    store.dispatch('entities/toplevel/initItems');
    if (
      !store.getters['entities/current'] ||
      store.getters['entities/current'].length === 0
    ) {
      basePlugin.onItemsLoaded((entitiesBasket) => {
        if (entitiesBasket.length > 0) {
          store.dispatch('entities/setCurrent', entitiesBasket);
        } else {
          basePlugin.onItemsLoaded((toplevelEntities) => {
            store.dispatch('entities/setCurrent', toplevelEntities);
          });
        }
      }, 'entities/basket');
    }
  });
};
